import React from 'react';
import PropTypes from 'prop-types';
import {QRCodeSVG, QRCodeCanvas} from 'qrcode.react';
import './qr-code.scss';

const QRCode = ({url}) => {
	return (
		<div className="QRCode">
			<QRCodeSVG
				id={'codeSvg'}
				value={url}
				bgColor={'#FFFFFF'}
				fgColor={'#000000'}
			/>
			<QRCodeCanvas
				id={'codePng'}
				value={url}
				bgColor={'#FFFFFF'}
				fgColor={'#000000'}
			/>
		</div>
	);
};

QRCode.propTypes = {
	url: PropTypes.string.isRequired
};

export default QRCode;